import styles from "@/components/corner-message.module.css";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { CornerMessageInfo } from "@/types";
import {
	Dialog,
	DialogBackdrop,
	DialogPanel,
	DialogTitle,
} from "@headlessui/react";
import clsx from "clsx";
import { JSX, useState } from "react";

interface CornerMessageProps {
	cornerMessage: CornerMessageInfo;
	right: number;
	top: number;
}

function CornerMessage({
	cornerMessage,
	right,
	top,
}: CornerMessageProps): JSX.Element {
	const [isClosing, setIsClosing] = useState(false);

	const paragraphElements = cornerMessage.text
		?.split("\n")
		.map((paragraph) => <p key={paragraph}>{paragraph}</p>);

	const handleClick = (): void => {
		globals.cornerMessageCallback?.();
		handleClose();
	};

	const handleClose = (): void => {
		setIsClosing(true);
		window.setTimeout(() => {
			signals.cornerMessage.value = {
				...signals.cornerMessage.value,
				isShown: false,
			};
			setIsClosing(false);
		}, globals.ANIMATION_WAIT_TIME);
	};

	return (
		<Dialog
			onClose={handleClose}
			open={cornerMessage.isShown || false}
		>
			<DialogBackdrop className="overlay" />
			<DialogPanel
				className={clsx(
					!isClosing && "fade-in-scale",
					isClosing && "fade-out-scale",
					styles["corner-message-container"],
				)}
				style={{
					right: right,
					top: top,
				}}
			>
				<DialogTitle as="h1">{cornerMessage.title}</DialogTitle>
				{paragraphElements}
				{cornerMessage.buttonText && (
					<button
						className={styles["button"]}
						onClick={handleClick}
						type="button"
					>
						{cornerMessage.buttonText}
					</button>
				)}
			</DialogPanel>
		</Dialog>
	);
}

export default CornerMessage;
